import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=bb37d110"
import script from "./page-title.vue?vue&type=script&lang=js"
export * from "./page-title.vue?vue&type=script&lang=js"
import style0 from "./page-title.vue?vue&type=style&index=0&id=bb37d110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports